import { observer } from "mobx-react";
import React, { useContext } from "react";
import styled from "styled-components";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import { WSFormGrid } from "../../../WSUtils/WSFormGrid";
import { CVEditContext } from "../CVEditContext";
import { CVEditAttachmentsSegment } from "./AttachmentsSegment/CVEditAttachmentsSegment";
import { CVEditDocumentsSegment } from "./DocumentSegment/CVEditDocumentSegment";

export const CVEditDocumentStep = withWSErrorContainer(
  observer(() => {
    const cvEditContext = useContext(CVEditContext);

    return (
      <CVEditDocumentStepStyles className="cve-document-step cve-step">
        {!cvEditContext.jobApplicationMode && <CVEditDocumentsSegment />}
        {!!cvEditContext.jobApplicationMode && <CVEditAttachmentsSegment />}
      </CVEditDocumentStepStyles>
    );
  })
);

const CVEditDocumentStepStyles = styled(WSFormGrid)`
  &.cve-document-step {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
`;
